import * as angular from "angular";
class NavbarController implements ng.IComponentController {

    private logo: string;
    private userName: string;

    constructor(private ThemeService: aboTheme.IThemeService) {
        'ngInject';
    }

    public $onInit = () => {
        this.logo = this.ThemeService.getLogoDark();
        console.log(this.userName);
    }

    private toggleSidebar = () => {
        angular.element('.app').toggleClass('offscreen move-left');
    }
};

export const navbar : aboTheme.IComponent = {
    bindings: {
        userName : '<'
    },
    controller: NavbarController,
    template: require('./navbar.html')
};



// WEBPACK FOOTER //
// ./~/@abosol/theme/src/app/main/navbar.component.ts